<template>
    <!-- TW Snippet Start v2.0+ -->
    <div style="z-index: 1000;" class="fixed bottom-1 inset-x-0 pb-1 sm:pb-3 pointer-events-none">
        <div style="pointer-events: all;" class="max-w-3xl mx-auto px-2 sm:px-6 lg:px-8">
            <div class="p-1 rounded-lg bg-indigo-50 border shadow-lg">
                <div class="flex items-center justify-between flex-wrap">
                    <div class="w-0 flex-1 flex items-center">

                        <p class="ml-3 font-medium text-indigo-500 truncate">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>
                                  Tento web používá soubory cookies podle <a class="underline" :href="route('policy.show')" target="_blank">zásad ochrany osobních údajů</a>.
                            </span>

                        </p>
                    </div>
                    <div class="order-2 shrink-0 sm:order-3 sm:ml-2">
                        <button @click="acceptCookies" type="button" class="ml-1 flex rounded-md focus:outline-none bg-green-500">
                            <span class="sr-only">Přijmout</span>
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                            </svg>
                        </button>
                    </div>
                    <div class="order-2 shrink-0 sm:order-3 sm:ml-1">
                        <button @click="dismissCookies" type="button" class="ml-1 flex rounded-md focus:outline-none bg-red-500">
                            <span class="sr-only">Odmítnout</span>
                            <!-- Heroicon name: outline/x -->
                            <svg class="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Cookies",
    emits: ['acceptCookies', 'dismissCookies'],
    data() {
        return {

        }
    },
    methods: {
        acceptCookies() {
            this.$emit('acceptCookies');
        },
        dismissCookies(){
            this.$emit('dismissCookies');
        }
    }
}
</script>

<style scoped>

</style>
